import type { PageType, PaginatedEvents } from '../../../types/PhotoCardType';
import type { InfiniteData } from 'react-query';

interface CollectedPhotoCardStats {
  selectedCount: number;
  collectedCount: number;
  totalCount: number;
  collectedPercentage: number;
  hasChanges: boolean;
}

interface CalculateStatsParams {
  currentMember: { memberId: string } | null;
  paginatedEvents: PaginatedEvents;
  selectedCollectedData: Record<string, Record<string, { collectedCount: number }>>;
  data: InfiniteData<PageType>;
}

export const calculateCollectedPhotoCardStats = ({
  currentMember,
  paginatedEvents,
  selectedCollectedData,
  data
}: CalculateStatsParams): CollectedPhotoCardStats => {
  const hasChanges = Object.keys(selectedCollectedData).some(
    (memberId) => Object.keys(selectedCollectedData[memberId] || {}).length > 0
  );

  const selectedCount = Object.values(selectedCollectedData).reduce(
    (total, memberData) => total + Object.keys(memberData || {}).length,
    0
  );

  if (!currentMember || !paginatedEvents || !data) {
    return {
      selectedCount,
      collectedCount: 0,
      totalCount: 0,
      collectedPercentage: 0,
      hasChanges
    };
  }

  const totalCount = data?.pages?.[0]?.meta?.photoCardsInfo?.totalCount || 0;

  let collectedCount = 0;
  paginatedEvents.forEach((event) => {
    event.photoCards?.forEach((photoCard) => {
      if (photoCard.memberId === currentMember.memberId) {
        const selectedData = selectedCollectedData[currentMember.memberId]?.[photoCard.photoCardId];
        if (selectedData?.collectedCount > 0 || (!selectedData && photoCard.collectedCount > 0)) {
          collectedCount++;
        }
      }
    });
  });

  const collectedPercentage =
    totalCount === 0 ? 0 : Math.round((collectedCount / totalCount) * 100);

  return {
    selectedCount,
    collectedCount,
    totalCount,
    collectedPercentage,
    hasChanges
  };
};
